import { RootState } from 'types'

type State = RootState['readReceipts']

export default function reduce(state: State = {}, { type, payload }: any): State {
  switch (type) {
    case 'UPSERT_READ_RECEIPTS': {
      const { readReceipts, articleId } = payload
      const activeTasksCount = readReceipts.my_tasks.length
      return { ...state, [articleId]: { ...readReceipts, activeTasksCount } }
    }
    case 'UPSERT_READ_RECEIPT': {
      const { readReceipt, articleId } = payload

      return {
        ...state,
        [articleId]: {
          ...state[articleId],
          my_requests: [...state[articleId].my_requests.filter((r) => r.id !== readReceipt.id), readReceipt],
          all_requests: [...state[articleId].all_requests.filter((r) => r.id !== readReceipt.id), readReceipt],
        },
      }
    }
    case 'REMOVE_READ_RECEIPT': {
      const { readReceiptId, articleId } = payload
      return {
        ...state,
        [articleId]: {
          ...state[articleId],
          my_requests: state[articleId].my_requests.filter((r) => r.id !== readReceiptId),
          all_requests: state[articleId].all_requests.filter((r) => r.id !== readReceiptId),
        },
      }
    }
    default:
      return state
  }
}
